import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, CustomEase);


export const teqAnimations = () => {
    document.fonts.ready.then(function () {

        gsap.utils.toArray(".showUp").forEach((element, i) => {
            gsap.from(element, {
                translateY: '30px',
                alpha: 0,
                duration: 1.8,
                ease: CustomEase.create("custom", "M0,0 C0.16,1 0.3,1 1,1 "),
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%",
                }
            });
        });

        gsap.utils.toArray(".showUpGroup").forEach((group) => {
            const elements = group.querySelectorAll('.showUpDelay')

                gsap.from(elements, {
                    translateY: '30px',
                    alpha: 0,
                    duration: 1.8,
                    stagger: 0.2,
                    ease: CustomEase.create("custom", "M0,0 C0.16,1 0.3,1 1,1 "),
                    scrollTrigger: {
                        trigger: group,
                        start: "top 80%",
                    }
                });
        
        });
        

        gsap.utils.toArray(".show").forEach((element, i) => {
            gsap.from(element, {
                alpha: 0,
                duration: 1.8,
                ease: CustomEase.create("custom", "M0,0 C0.16,1 0.3,1 1,1 "),
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%",
                }
            });
        });

        gsap.utils.toArray(".animImg").forEach((element, i) => {
            const overview = element.querySelector('.overview')
            const image = element.querySelector('img')

            gsap.to(overview, {
                scaleY: 0,
                duration: 1,
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%",
                }
            });

            gsap.to(image, {
                opacity: 1,
                duration: 0.2,
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%",
                }
            });
        })

        gsap.utils.toArray(".animImgGroup").forEach((group, i) => {
            const elements = group.querySelectorAll('.animImgDelay')
        
            gsap.utils.toArray(elements).forEach((element, i) => {
                const overview = element.querySelector('.overview')
                const image = element.querySelector('img')
    
                gsap.to(overview, {
                    scaleY: 0,
                    duration: 1,
                    delay: i !== 0 ? `0.${i + 2}` : 0,
                    scrollTrigger: {
                        trigger: group,
                        start: "top 90%",
                    }
                });
    
                gsap.to(image, {
                    opacity: 1,
                    duration: 0.2,
                    delay:i !== 0 ? `0.${i + 2}` : 0,
                    scrollTrigger: {
                        trigger: group,
                        start: "top 90%",
                    }
                });
            })
        })

        ScrollTrigger.update();
    })
}
